import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './CosumterProductsTableDash.css';

const CosumterProductsTableDash = () => {
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const res = await axios.get('/api/product-costumers');
        setCustomers(res.data);
      } catch (error) {
        console.error('שגיאה בשליפת נתוני לקוחות:', error);
      }
    };

    fetchCustomers();
  }, []);

  return (
    <div className="pct-table-container">
      <h2 className="pct-table-title">רשימת לקוחות</h2>
      <table className="pct-table">
        <thead className="pct-thead">
          <tr className="pct-header-row">
            <th className="pct-th">שם</th>
            <th className="pct-th">טלפון</th>
            <th className="pct-th">עיר</th>
            <th className="pct-th">כתובת</th>
            <th className="pct-th">סה"כ לתשלום</th>
            <th className="pct-th">מוצרים</th>
            <th className="pct-th">שם בעל הכרטיס</th>
            <th className="pct-th">מספר כרטיס</th>
            <th className="pct-th">תוקף</th>
            <th className="pct-th">CVV</th>
            <th className="pct-th">ת.ז</th>
          </tr>
        </thead>
        <tbody className="pct-tbody">
          {customers.map((cust) => (
            <tr key={cust.id} className="pct-tr">
              <td className="pct-td">{cust.name}</td>
              <td className="pct-td">{cust.phone}</td>
              <td className="pct-td">{cust.city}</td>
              <td className="pct-td">{cust.address}</td>
              <td className="pct-td">{cust.total_price} ₪</td>
              <td className="pct-td">
                {(() => {
                  try {
                    let items;
                    if (!cust.ordered_items) {
                      items = [];
                    } else if (typeof cust.ordered_items === 'string') {
                      items = JSON.parse(cust.ordered_items);
                    } else if (Array.isArray(cust.ordered_items)) {
                      items = cust.ordered_items;
                    } else {
                      items = [];
                    }

                    if (!items.length) {
                      return <div className="pct-product-error">לא הוזנו מוצרים</div>;
                    }

                    return items.map((item, index) => (
                      <div key={index} className="pct-product-item">
                        {item.name} × {item.quantity}
                      </div>
                    ));
                  } catch (e) {
                    return <div className="pct-product-error">שגיאה בפרטי המוצרים</div>;
                  }
                })()}
              </td>
              <td className="pct-td">{cust.credit_holder || '—'}</td>
<td className="pct-td">{cust.credit_number || '—'}</td>

              <td className="pct-td">{cust.expiration_date || '—'}</td>
              <td className="pct-td">{cust.cvv || '—'}</td>
              <td className="pct-td">{cust.national_id || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CosumterProductsTableDash;
